import { CSSProperties, FC, HTMLAttributes } from 'react';
import styles from './Skeleton.module.scss';
interface SkeletonProps extends HTMLAttributes<HTMLDivElement> {
  variant?: 'text' | 'rectangular' | 'circular' | 'rounded';
  width?: number | string;
  height?: number | string;
  className?: string;
  data_cy?: string;
}
const Skeleton: FC<SkeletonProps> = ({
  variant = 'text',
  width,
  height,
  className = '',
  data_cy,
  ...props
}) => {
  const skeletonStyle: CSSProperties = {
    width,
    height
  };
  return <div {...props} className={`${styles.skeleton} ${styles[variant]} ${className}`} style={skeletonStyle} data-cy={data_cy} data-sentry-component="Skeleton" data-sentry-source-file="Skeleton.tsx" />;
};
export default Skeleton;